import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  DocumentJSON,
  GetProjectDocumentDataResponse,
  GetProjectDocumentJSONResponse,
  ProjectDocumentData,
} from "../../models/ProjectDocument.model";
import {
  getProjectDocumentData,
  getProjectDocumentJSON,
  sendCopyDoc,
} from "../thunks/projectDocumentThunks";

interface ProjectDocumentDataSliceState {
  projectDocumentData: ProjectDocumentData | null;
  loading: boolean;
  error: string | null;
  projectDocumentJSON: DocumentJSON | null;
}

const initialState: ProjectDocumentDataSliceState = {
  projectDocumentData: null,
  loading: false,
  error: null,
  projectDocumentJSON: null,
};

const projectDocumentDataSlice = createSlice({
  name: "projectDocumentData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProjectDocumentData.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.projectDocumentData = null;
        state.projectDocumentJSON = null;
      })
      .addCase(
        getProjectDocumentData.fulfilled,
        (state, action: PayloadAction<GetProjectDocumentDataResponse>) => {
          state.loading = false;
          state.projectDocumentData = action.payload.projectData;
        },
      )
      .addCase(getProjectDocumentData.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "שגיאה בטעינת נתוני מסמך";
      })
      .addCase(sendCopyDoc.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendCopyDoc.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(sendCopyDoc.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "שגיאה בשליחת העותק";
      })
      .addCase(getProjectDocumentJSON.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.projectDocumentJSON = null;
      })
      .addCase(
        getProjectDocumentJSON.fulfilled,
        (state, action: PayloadAction<GetProjectDocumentJSONResponse>) => {
          state.loading = false;
          state.projectDocumentJSON = action.payload.documentJSON;
        },
      )
      .addCase(getProjectDocumentJSON.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) || "שגיאה בטעינת נתוני מסמך JSON";
      });
  },
});

export default projectDocumentDataSlice.reducer;
